import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  height: 92vh;
  background-color: #f4f4f4;
  background-image: url("/assets/bg.png");
  background-size: cover;
`;

export const LoginBox = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 300px;
  text-align: center;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px;
  margin: 10px 0;
  background-color: #fff;
`;

export const Icon = styled.div`
  margin: 0 10px;
  color: #0066cc;
`;

export const InputTextWithIcon = ({ icon, ...props }) => (
  <div style={{ position: "relative", width: "100%" }}>
    <FontAwesomeIcon
      icon={icon}
      style={{
        position: "absolute",
        left: "13px",
        top: "48%",
        transform: "translateY(-50%)",
        color: "#888",
      }}
    />
    <textarea
      {...props}
      style={{
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "5px",
        fontSize: "13px",
        resize: "vertical",
        paddingLeft: "35px",
        width: "100%",
        height: "40px",
        fontFamily: "Inter, sans-serif",
      }}
    />
  </div>
);

export const InputWithIcon = ({ icon, ...props }) => (
  <div style={{ position: "relative", width: "100%" }}>
    <FontAwesomeIcon
      icon={icon}
      style={{
        position: "absolute",
        left: "13px",
        top: "48%",
        transform: "translateY(-50%)",
        color: "#888",
      }}
    />
    <Input
      {...props}
      style={{
        paddingLeft: "35px", // Space for the icon
        width: "100%",
        height: "40px",
      }}
    />
  </div>
);

export const SelectInputWithIcon = ({ icon, ...props }) => (
  <div style={{ position: "relative", width: "100%" }}>
    <FontAwesomeIcon
      icon={icon}
      style={{
        position: "absolute",
        left: "13px",
        top: "48%",
        transform: "translateY(-50%)",
        color: "#888",
      }}
    />
    <select
      {...props}
      style={{
        paddingLeft: "35px", // Space for the icon
        width: "100%",
        height: "40px",
        borderRadius: "5px",
        border: "1px solid #ccc",
        outline: "none",
      }}
    />
  </div>
);

export const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  color: #17224d;
`;
export const ButtonContainer = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export const Button = styled.button`
  width: 50%;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  padding: 10px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: none;
  background-color: #17224d;
  color: #fff;
  cursor: pointer;
  margin-top: 10px;
`;

export const ButtonIcon = styled(FontAwesomeIcon)`
  @media (max-width: 500px) {
    margin-right: 0;
  }
`;

export const ButtonText = styled.p`
  color: white;
  @media (max-width: 500px) {
    display: none;
  }
`;

export const Modal = styled.div`
  background: white;
  padding: 20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  z-index: 1000;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const AdminContainer = styled.div`
  background-color: #fff;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  width: 80%;
  overflow-y: auto;
  max-width: 1200px;
  height: 80vh;

  h2 {
    margin-bottom: 20px;
  }

  .vacancy-row {
    display: grid;

    @media (max-width: 900px) {
      grid-template-columns: repeat(1, 1fr);
    }
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }

  /* Custom scrollbar styles */
  ::-webkit-scrollbar {
    width: 6px; /* Smaller scrollbar width */
    height: 6px; /* Smaller horizontal scrollbar width */
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #0066cc;
    border-radius: 10px;
    border: 3px solid #f1f1f1; /* Adds a gap around the thumb */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #005bb5;
  }
`;

export const VacancyCard = styled.div`
  background-color: #f9f9f9;
  border-radius: 10px;
  border: 2px solid #17224d;
  padding: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);

  h3 {
    margin: 0;
  }

  p {
    font-size: 14px;
    color: #555;
  }

  span {
    display: block;
    margin-top: 10px;
    color: #777;
  }

  div {
    margin-top: 15px;
  }
`;

export const NavBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  background-color: #17224d;
  padding: 10px;
  border-radius: 5px;
  color: #fff;

  span {
    font-size: 16px;
    font-weight: bold;
  }

  button {
    border: none;
    padding: 10px 15px;
    color: #fff;
    cursor: pointer;
    border-radius: 5px;
  }

  /* Navigation links section */
  .nav-links {
    display: flex;
    gap: 20px; /* Space between links */
    margin-right: 20px; /* Some margin to the right */
  }

  .nav-link {
    color: white;
    text-decoration: none;
    font-size: 13px;
    font-weight: 500;
    padding: 10px 15px;
    background-color: #17224d;
    border-radius: 5px;
    transition: background-color 0.3s;
  }

  .nav-link:hover {
    background-color: rgb(29, 41, 89); /* Hover effect for links */
    color: white;
  }

  .active {
    background-color: white;
    color: #17224d;
  }
`;
